module.exports = __webpack_public_path__ + "img/neoline.9ef2156a.svg";